__turbopack_context__.v({
  "container": "NewArticleLayoutHeader-module-scss-module__ypY5Xq__container",
  "contentContainer": "NewArticleLayoutHeader-module-scss-module__ypY5Xq__contentContainer",
  "isTemplate": "NewArticleLayoutHeader-module-scss-module__ypY5Xq__isTemplate",
});
